import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Mail, ArrowLeft, ShieldAlert } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
      toast.success("Reset uplink dispatched successfully.");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Failed to trigger password reset");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-24">
      <div className="rtrl-card carbon-bg p-8 border border-rtrl-red/30 shadow-[0_0_40px_rgba(229,25,25,0.05)] relative overflow-hidden">
        <div className="absolute inset-0 grid-bg opacity-10 pointer-events-none" />
        <div className="scanline" />

        <div className="relative z-10 space-y-6">
          <div className="text-center space-y-2">
            <ShieldAlert className="w-12 h-12 text-rtrl-red mx-auto animate-pulse" />
            <div className="small-label text-rtrl-red">Terminal Recovery</div>
            <h1 className="font-display uppercase text-4xl text-white">Reset Password</h1>
          </div>

          {!sent ? (
            <form onSubmit={submit} className="space-y-6">
              <p className="text-white/60 text-xs leading-relaxed text-center">
                Enter your registered pilot email below. We will dispatch a secure link to configure a new access credential terminal.
              </p>
              <div>
                <label className="small-label flex items-center gap-1"><Mail className="w-3.5 h-3.5" /> Pilot Email</label>
                <input
                  data-testid="forgot-email"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="racer@rtrl-league.com"
                  className="rtrl-input text-sm placeholder-white/10"
                />
              </div>

              <button
                data-testid="forgot-submit"
                disabled={busy}
                className="rtrl-btn w-full justify-center"
              >
                {busy ? "Sending Link…" : "Send Reset Link"}
              </button>
            </form>
          ) : (
            <div className="text-center space-y-4 py-4">
              <p className="text-white/80 text-sm font-medium leading-relaxed">
                If the email is verified, a recovery link has been sent to <br/>
                <span className="text-rtrl-red font-mono-tech truncate block mt-1">{email}</span>
              </p>
              <p className="text-white/55 text-xs">Please check your inbox or spam filters and follow the instructions to reset your access.</p>
            </div>
          )}

          <div className="pt-4 border-t border-surface-line/40 text-center">
            <Link to="/login" className="text-xs font-mono-tech text-rtrl-silver hover:text-white transition-colors flex items-center justify-center gap-1.5" data-testid="forgot-back-to-login">
              <ArrowLeft className="w-4 h-4" /> Back to Log In
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}